import { plural } from '@remote-medium/shared';
import { Button } from '@remote-medium/ui';
import type { ReactNode } from 'react';

// Shown when a curator rejects an added skill or role type that is already in
// use: says how much it is linked to and asks for a replacement first, either
// an existing entry (the Replace picker above) or a new one added here.
export function RejectInUse({
  name,
  roleCount,
  candidateCount,
  consequence,
  addFields,
  canAdd,
  busy,
  onAdd,
  onRejectAnyway,
  onCancel,
}: {
  name: string;
  roleCount: number;
  candidateCount: number;
  /** What rejecting does to those links, as a sentence. */
  consequence: string;
  /** Inputs for the new entry (name plus category or family). */
  addFields: ReactNode;
  canAdd: boolean;
  busy: boolean;
  onAdd: () => void;
  onRejectAnyway: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-border bg-muted/40 p-3">
      <p className="m-0 max-w-[60ch] text-sm">
        “{name}” is already linked to {plural(roleCount, 'role')} and{' '}
        {plural(candidateCount, 'candidate')}. {consequence} Give them a replacement instead: pick
        an existing one under “Replace with existing…” above, or add the right one here.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {addFields}
        <Button size="sm" variant="outline" disabled={busy || !canAdd} onClick={onAdd}>
          Add and replace
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="destructive" disabled={busy} onClick={onRejectAnyway}>
          Reject anyway
        </Button>
        <Button size="sm" variant="ghost" disabled={busy} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
